import React from "react";
import { connect } from "react-redux";

import FileUploader from "../../components/fileUploader/FileUploader";

import { uploadChecklist } from "../../redux/checklists/actions";
import * as authSelectors from "../../redux/auth/selectors";

class ChecklistUploader extends React.Component {
  fileInputRef = React.createRef();

  render() {
    const { userId, uploadChecklist } = this.props;
    return (
      <FileUploader
        fileInputRef={this.fileInputRef}
        userId={userId}
        onUploadFile={uploadChecklist}
        entity="checklist"
      />
    );
  }
}

export default connect(
  state => ({
    userId: authSelectors.getUserId(state)
  }),
  {
    uploadChecklist
  }
)(ChecklistUploader);
